import PropTypes from 'prop-types';
import { useEffect, useReducer, useCallback, useMemo, useState, useRef } from 'react';
// utils
import axios from '../../../utils/axios';
import localStorageAvailable from '../../../utils/localStorageAvailable';
//
import { isValidToken, setSession } from './utils';
import { AuthContext } from './auth-context';
import { IS_DEV } from '../../../config-global';

// ----------------------------------------------------------------------

// NOTE:
// We only build demo at basic level.
// Customer will need to do some extra handling yourself if you want to extend the logic and other features...

// ----------------------------------------------------------------------

const initialState = {
  isInitialized: false,
  isAuthenticated: false,
  user: null,
};

const reducer = (state, action) => {
  if (action.type === 'INITIAL') {
    console.log("Reducer: INITIAL", action.payload);
    return {
      isInitialized: true,
      isAuthenticated: action.payload.isAuthenticated,
      user: action.payload.user,
    };
  }
  if (action.type === 'LOGIN') {
    console.log("Reducer: LOGIN", action.payload);
    return {
      ...state,
      isAuthenticated: true,
      user: action.payload.user,
    };
  }
  if (action.type === 'REGISTER') {
    return {
      ...state,
      isAuthenticated: true,
      user: action.payload.user,
    };
  }
  if (action.type === 'LOGOUT') {
    return {
      ...state,
      isAuthenticated: false,
      user: null,
    };
  }

  return state;
};

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

const tg = window.Telegram?.WebApp || null;
export function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const [typeReady, setTypeReady] = useState(false);
  const userTypeRef = useRef('default');
  const setUserType = (type) => {
    console.log('[AuthProvider] setUserType called:', type); // ✅ DEBUG
    userTypeRef.current = type || 'default';
    setTypeReady(true);
  };

  const windowlocation = window.location.pathname;
  console.log("shopid windowlocation=>", windowlocation);

  const shopid = getShopIdFromPathname(windowlocation);
  console.log("shopid =>>>>", shopid);

  const storageAvailable = localStorageAvailable();

  // TG LOGIN
  const tgLogin = useCallback(async (tg_response) => {

    const currentShopId = shopid || 'main';
    console.log("tg resp =>", {
      tg_response, shop_id: currentShopId, type: "user"
    });
    const response = await axios.post('/auth', {
      tg_response, shop_id: currentShopId, type: "user"
    }, {
      headers: {
        Authorization: null
      }
    });

    console.log("TG LOGIN", response);
    const { accessToken, user } = response.data;
    // const acts = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoidGc2NzkwNzg2NDA5IiwiZXhwIjoxNzA5Mjk0OTEyLCJzdWIiOiJhY2Nlc3MifQ.Xr-IcYeL9E91Z3K0BOd_nD1DG2GdwiR0pX-Cm5akRr4";
    // setSession(acts);
    setSession(accessToken);
    localStorage.removeItem('isLoggedOut');


    dispatch({
      type: 'LOGIN',
      payload: {
        user,
      },
    });

    return { user }; // ✅ возвращаем, чтобы initialize знал, кого залогинили

  }, [shopid]);

  // YANDEX LOGIN
  const yandexLogin = useCallback(async (access_token, isLinkingRequested = false) => {
    const currentShopId = shopid || 'main';
    console.log("Yandex Login starting with token", access_token);

    // Читаем токен напрямую из localStorage (как в initialize и utils)
    const currentToken = localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');

    // Если мы на странице логина, мы НЕ считаем себя залогиненными для целей обновления токена
    const isCurrentlyLoggedIn = !!currentToken;

    const response = await axios.post('/partners/auth/yandex', {
      access_token,
      current_token: isCurrentlyLoggedIn ? currentToken : null,
      shop_id: currentShopId,
      type: "user"
    }, {
      headers: {
        Authorization: null
      }
    });

    console.log("YANDEX LOGIN Response", response.data);
    const { accessToken, user } = response.data;

    // ✅ Если это ВХОД (isLinkingRequested = false), то ВСЕГДА устанавливаем сессию
    // Если это ПРИВЯЗКА (isLinkingRequested = true), то сессию НЕ перезаписываем
    if (!isLinkingRequested) {
      console.log('[AuthProvider] Setting new Yandex session...');
      setSession(accessToken);
      localStorage.removeItem('isLoggedOut');

      dispatch({
        type: 'LOGIN',
        payload: {
          user: {
            ...user,
            yandex_linked: true
          },
        },
      });
    } else {
      console.log('[AuthProvider] Account linked successfully. Preserving current TG session.');
      // Запрашиваем актуальный статус привязки после успешного линкования
      setTimeout(() => checkYandexStatus(), 500);
    }

    return { user };
  }, [shopid]);

  // CHECK YANDEX STATUS
  const checkYandexStatus = useCallback(async () => {
    try {
      const response = await axios.get('/partners/yandex-status');
      if (response.data.success && response.data.linked) {
        dispatch({
          type: 'LOGIN',
          payload: {
            user: {
              ...state.user,
              yandex_linked: true,
              yandex_email: response.data.email
            }
          }
        });
      }
    } catch (error) {
      console.error('[AuthProvider] Failed to fetch Yandex status:', error.message);
    }
  }, [state.user]);


  //   try {
  //     const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';
  //
  //     if (accessToken && isValidToken(accessToken)) {
  //       setSession(accessToken);
  //
  //       const response = await axios.get('/account/my-account');
  //       // console.log(response);
  //       const { user } = response.data;
  //
  //       dispatch({
  //         type: 'INITIAL',
  //         payload: {
  //           isAuthenticated: true,
  //           user,
  //         },
  //       });
  //     } else {
  //       dispatch({
  //         type: 'INITIAL',
  //         payload: {
  //           isAuthenticated: false,
  //           user: null,
  //         },
  //       });
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     dispatch({
  //       type: 'INITIAL',
  //       payload: {
  //         isAuthenticated: false,
  //         user: null,
  //       },
  //     });
  //   }
  // }, [storageAvailable]);

  // initialize — функция инициализации аутентификации при старте приложения
  const initialize = useCallback(async () => {
    try {
      // Проверяем наличие токена в localStorage
      const accessToken = storageAvailable ? localStorage.getItem('accessToken') : null;
      console.log("accessToken", accessToken);
      if (accessToken && isValidToken(accessToken)) {
        // Авторизуем пользователя по токену
        console.log("Initialize: Token found and valid", accessToken);
        setSession(accessToken);
        const response = await axios.get('/account/my-account');
        const { user } = response.data;

        dispatch({
          type: 'INITIAL',
          payload: {
            isAuthenticated: true,
            user,
          },
        });

        // После инициализации проверяем статус Яндекса
        checkYandexStatus();

        return; // Завершаем инициализацию
      }

      // Если токена нет, проверяем запуск из Telegram WebApp
      const initData = tg?.initData; // tg.initDataUnsafe //


      const isLoggedOut = localStorage.getItem('isLoggedOut') === 'true';
      console.log("Initialize: initData present", !!initData, "isLoggedOut", isLoggedOut);

      if (initData && !isLoggedOut) {
        // Авторизация через Telegram WebApp
        console.log("INIT DATA start");
        const { user } = await tgLogin(initData); // вызываем tgLogin с initData
        console.log("INIT DATA user", user);
        // После успешного логина диспетчим INITIAL с isAuthenticated=true
        dispatch({
          type: 'INITIAL',
          payload: {
            isAuthenticated: true,
            user,
          },
        });
        return; // Завершаем инициализацию
      }
      console.log("Ничего нет");
      // Если ничего нет, считаем пользователя неавторизованным
      dispatch({
        type: 'INITIAL',
        payload: {
          isAuthenticated: false,
          user: null,
        },
      });

    } catch (error) {
      console.error('Auth initialize error:', error);
      dispatch({
        type: 'INITIAL',
        payload: {
          isAuthenticated: false,
          user: null,
        },
      });
    }
  }, [storageAvailable, tgLogin]);



  useEffect(() => {
    initialize();
  }, [initialize]);



  // LOGIN
  const login = useCallback(async (email, password) => {
    const response = await axios.post('/api/account/login', {
      email,
      password,
    });
    const { accessToken, user } = response.data;

    setSession(accessToken);
    localStorage.removeItem('isLoggedOut');

    dispatch({
      type: 'LOGIN',
      payload: {
        user: {
          ...user,    // 1. Копируем все свойства из оригинального объекта user
          shopid // 2. Добавляем (или перезаписываем) свойство shopid
        },
      },
    });
  }, [shopid]);

  // REGISTER
  const register = useCallback(async (email, password, firstName, lastName) => {
    const response = await axios.post('/api/account/register', {
      email,
      password,
      firstName,
      lastName,
    });
    const { accessToken, user } = response.data;

    localStorage.setItem('accessToken', accessToken);

    dispatch({
      type: 'REGISTER',
      payload: {
        user,
      },
    });
  }, []);

  // LOGOUT
  const logout = useCallback(() => {
    setSession(null);
    localStorage.removeItem('accessToken'); // Explicitly remove token
    localStorage.setItem('isLoggedOut', 'true');
    dispatch({
      type: 'LOGOUT',
    });
  }, []);

  const memoizedValue = useMemo(
    () => ({
      user: state.user,
      // bot: state.bot,
      isInitialized: state.isInitialized,
      isAuthenticated: state.isAuthenticated,
      loading: !state.isInitialized,
      method: 'jwt',
      shopid,
      login,
      register,
      logout,
      tgLogin,
      yandexLogin,
      setUserType
    }),
    [state.isInitialized, state.isAuthenticated, state.user, shopid, login, register, logout, tgLogin, yandexLogin]
  );

  return <AuthContext.Provider value={memoizedValue}>{children}</AuthContext.Provider>;
}


function getShopIdFromPathname(strPathname) {
  const patterns = [

    // паттерн для пути /dashboard/app/shop/<shopId>
    /^\/dashboard\/app\/shop\/([a-zA-Z0-9]{15,}|main)(?:\/|\?|$)/,
    // Пути, где shopid идёт сразу после префикса
    /^\/(?:shop|lp|event|games|product)\/([a-zA-Z0-9]{15,}|main)(?:\/|\?|$)/,

    // Пути, где shopid идёт после dashboard/...
    /^\/dashboard\/(?:shop|shops|stories|usercard|general|pages|orders|analytics|notify|subscribers|referals|forms|quizzes|integrations|settings|pays)\/([a-zA-Z0-9]{15,}|main)(?:\/|\?|$)/,

    // Пути, где shopid идёт после dashboard/general/...
    /^\/dashboard\/general\/(?:shop|usercard|usercardchoice|settings|articles|tools|qs|chatbot|goods|pages|payment|paymentManual|promotions|affiliate|paymentAuto)\/([a-zA-Z0-9]{15,}|main)(?:\/|\?|$)/,

    // Пути, где shopid идёт после dashboard/notify/...
    /^\/dashboard\/notify\/(?:auto\/element\/)?([a-zA-Z0-9]{15,}|main)(?:\/|\?|$)/,

    // Пути, где shopid идёт после product/...
    /^\/product\/(?:shop|article)\/([a-zA-Z0-9]{15,}|main)(?:\/|\?|$)/,

    // Специфический путь dashboard/notify/.../list/
    /^\/dashboard\/notify\/([a-zA-Z0-9]{15,}|main)\/list\//,

    // /dashboard/forms/answer_comments/...
    /^\/dashboard\/forms\/answer_comments\/([a-zA-Z0-9]{15,}|main)(?:\/|\?|$)/,

    // /profile/forms/answer_comments/...
    /^\/profile\/forms\/answer_comments\/([a-zA-Z0-9]{15,}|main)(?:\/|\?|$)/,

    /^\/dashboard\/employees\/([a-zA-Z0-9]{15,}|main)\/account(?:\/|\?|$)/,

    /^\/dashboard\/employees\/shop\/([a-zA-Z0-9]{15,}|main)\/account(?:\/|\?|$)/,

    /^\/dashboard\/employees\/shop\/([a-zA-Z0-9]{15,}|main)(?:\/|\?|$)/,

    /^\/dashboard\/calendar\/shop\/([a-zA-Z0-9]{15,}|main)(?:\/|\?|$)/,

  ];

  let shopId = "";
  patterns.forEach((pattern) => {
    const match = strPathname.match(pattern);
    if (match && !shopId) {
      shopId = match[1];
      if (IS_DEV) {
        console.log(`Extracted shopId from pathname "${strPathname}":`, shopId);
      }
    }
  });

  if (!shopId && IS_DEV) {
    console.log(`No shopId found in pathname "${strPathname}"`);
  }

  return shopId;
}
